// relative
import { energyAnalysisApiSlice } from '../apiSlice';

export const systemQoSApiSlice = energyAnalysisApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllSystemQoS: builder.query({
      query: () => `/all_system_qos`,
      providesTags: ['EnergyAnalysis'],
    }),

    getSystemQoSById: builder.query({
      query: ({ energyGroupId, accountId }) => ({
        url: `/system_qos/${accountId}/${energyGroupId}`,
      }),
      providesTags: ['EnergyAnalysis'],
    }),

    postExtractConfigurationCheck: builder.mutation({
      query: ({ selectedEnergyGroup }) => ({
        url: `/extract_configuration_check?language=da`,
        method: 'POST',
        body: selectedEnergyGroup,
      }),
      invalidatesTags: ['EnergyAnalysis'],
    }),
  }),
});

export const {
  useGetAllSystemQoSQuery,
  useGetSystemQoSByIdQuery,
  useLazyGetSystemQoSByIdQuery,
  usePostExtractConfigurationCheckMutation,
} = systemQoSApiSlice;
